import { UserRole } from 'models/User'
import { BUSINESS_ROLES, UPSHIFTER_ROLES, ADMIN_ROLE } from 'models/Auth'
import { mapUserRoleToUserRoleInApp } from 'helpers/permissionsHelpers/roleHelpers'
import { laborUser, businessUser, employeeUser } from './utils'

export const shouldUseLoginCheck = response => {
  const { roles, site } = response
  const userRole = mapUserRoleToUserRoleInApp(roles[0].name, site)
  return (
    BUSINESS_ROLES.indexOf(userRole) >= 0 ||
    UPSHIFTER_ROLES.indexOf(userRole) >= 0
  )
}

export const isUserAdmin = role => {
  const roles = Object.keys(ADMIN_ROLE).map(key => {
    return ADMIN_ROLE[key]
  })
  if (roles.indexOf(role) >= 0) return true
  return false
}

export const userResponseMapper = response => {
  let loggedInUser = null

  if (response.meta.code === 200) {
    switch (response.data.roles[0].name) {
      case UserRole.BUSINESS:
        loggedInUser = businessUser(response.data)
        break
      case UserRole.APPROVER:
      case UserRole.VIEWER:
      case UserRole.FINANCE_MANAGER:
      case UserRole.EMPLOYEE:
        loggedInUser = employeeUser(response.data)
        break
      // TODO: Remove this case when BE implementation is done
      case 'labor':
        loggedInUser = laborUser(response.data)
        break
      default:
        break
    }
  }
  return loggedInUser
}

export default '*'
